// src/utils/healthCheck.js
import axios from 'axios'

interface HealthCheckResponse {
  api: boolean
  cdn: boolean
}

/**
 * Health Check for API and CDN
 * @param timezone string
 */
export async function healthCheck(): Promise<HealthCheckResponse> {
  try {
    console.info('%cChecking health...', 'color: cyan; font-weight: bold;')
    // Replace these URLs with your actual API and CDN health check endpoints
    const apiResponse = await axios.get(import.meta.env.VITE_API_BASE_URL + '/healthcheck.php')
    const cdnResponse = await axios.get(import.meta.env.VITE_CDN_BASE_URL + '/healthcheck.php')

    const apiStatusColor = apiResponse.status === 200 ? 'green' : 'red'
    const cdnStatusColor = cdnResponse.status === 200 ? 'green' : 'red'

    console.info(`%cHealth - API: ${apiResponse.status}`, `color: ${apiStatusColor}; font-weight: bold;`)
    console.info(`%cHealth - CDN: ${cdnResponse.status}`, `color: ${cdnStatusColor}; font-weight: bold;`)

    if (apiResponse.status === 200 && cdnResponse.status === 200) {
      return { api: true, cdn: true }
    } else {
      return { api: apiResponse.status === 200, cdn: cdnResponse.status === 200 }
    }
  } catch (error) {
    console.error(error)
    return { api: false, cdn: false }
  }
}
